import * as React from 'react';
import { Typography, useTheme } from '@mui/material';
import { AssistanceCardContactItem } from './AssistanceCardContactItem';
import { type UserCardUserType } from '../UserContactCard';

export type AssistanceCardView = 'menu' | 'formaliste' | 'commercial';

export interface AssistanceCardMenuProps {
    formalisteUserData: UserCardUserType | null;
    commercialUserData: UserCardUserType | null;
    isLoadingContacts: boolean;
    onSelectContact: (view: AssistanceCardView) => void;
}

export const AssistanceCardMenu: React.FunctionComponent<AssistanceCardMenuProps> = function ({
    formalisteUserData,
    commercialUserData,
    isLoadingContacts,
    onSelectContact,
}) {
    const theme = useTheme();

    const contactItems = [
        {
            title: 'Contacter votre formaliste',
            description: 'Pour toutes demandes liées aux formalités',
            view: 'formaliste' as AssistanceCardView,
            userData: formalisteUserData,
        },
        {
            title: 'Contacter votre commercial',
            description: 'Pour toutes demandes liées à votre offre Legal2Digital',
            view: 'commercial' as AssistanceCardView,
            userData: commercialUserData,
        },
    ];

    return (
        <>
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.grey[600],
                    marginBottom: '16px',
                    textAlign: 'left',
                }}
            >
                Nos équipes sont là pour vous aider.
            </Typography>
            {contactItems.map((item) => (
                <AssistanceCardContactItem
                    key={item.view}
                    title={item.title}
                    description={item.description}
                    userData={item.userData}
                    isLoading={isLoadingContacts}
                    onClick={() => onSelectContact(item.view)}
                />
            ))}
        </>
    );
};
